export const CREDIT_CARD_REMOVED = '@@mah-maps/CREDIT_CARD_REMOVED';
export const CREDIT_CARD_ADDED = '@@mah-maps/CREDIT_CARD_ADDED';
export const CREDIT_CARD_ADD_FAILED = '@@mah-maps/CREDIT_CARD_ADD_FAILED';
export const CREDIT_CARDS_LOADED = '@@mah-maps/CREDIT_CARDS_LOADED';
export const PAYMENT_TOKEN_FETCHED = '@@mah-maps/PAYMENT_TOKEN_FETCHED';
export const CREDIT_CARD_CLEAN_ERROR = '@@mah-maps/CREDIT_CARD_CLEAN_ERROR';
export const STORE_CURRENT_CARD = '@@mah-maps/STORE_CURRENT_CARD';